import React from 'react';
import i18next from '../../../config/i18next';

import {
  Button,
  Loader,
  Divider,
  WysiwygField,
} from '../../../components';

import './style.scss';

const ViewAwards = ({ pager, onLoadMore, loading, setResults, ...props }) => {
  const { entities } = props;
  const currencyFormatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const totalPages = pager.get('total_pages');
  const currentPage = pager.get('current_page');
  setResults(entities.size);
  return (
    <div className="ViewAwards">
      <table>
        <thead>
          <tr>
            <th>Organisatie</th>
            <th>Omschrijving</th>
            <th>Euro</th>
          </tr>
        </thead>
        <Divider />
        <tbody>
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            return (
              <tr key={id}>
                <td>{entity.getIn(['field_address', 0, 'organization'])}</td>
                <td>
                  <WysiwygField
                    aria-label="Award text"
                    property="schema:text"
                    html={entity.getIn(['field_description', 0, 'processed'], '')}
                  />
                </td>
                <td>{currencyFormatter.format(entity.getIn(['field_sum', 0, 'value']))}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      { currentPage < totalPages && (
        <div className="ViewAwards__button">
          <Button
            className="ViewAwards__Button"
            secondary
            withIcon
            buttonIconVertical
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onLoadMore();
            }}>{ i18next.t('awards_view_load_more') }
          </Button>
        </div>
      )}
      <Loader loading={loading} />
    </div>
  );
};

export default ViewAwards;
